import { render, staticRenderFns } from "./listing-task-tracker.vue?vue&type=template&id=4afd50f2"
import script from "./listing-task-tracker.vue?vue&type=script&lang=js"
export * from "./listing-task-tracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports